<template>

  <div id="#dlnkcalendar-events-display" class="row w-100 mt-2">

    <div class="col-md-4">
      <FullCalendar :key="calendar_key" :options="calendar_options" ref="eventCalendar"/>
    </div>


    <div class="col-md-8">

      <div class="col-md-12">
        <div class="content_sortPagiBar">
          <div class="top-pagination-content clearfix">

            <!-- Pagination -->
            <dlnkpagination
                :page="events_page"
                :page_count="events_page_count"
                @next_page="next_event_page()"
                @prev_page="prev_event_page()"
                @set_page="set_event_page($event)">
            </dlnkpagination>
            <!-- End Pagination -->

          </div>
        </div>
        <!-- Modal event information -->
        <div class="modal fade" id="event-more" tabindex="-1" role="dialog" aria-labelledby="Modal event">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">{{current_event.event_name}}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                    aria-hidden="true">×</span></button>
              </div>
              <div class="modal-body">
                <div class="row bg-light p-3 mt-2 rounded">
                                    <span class="col-6 text-left mb-1">
                                        <i class="fa fa-fw fa-calendar" aria-hidden="true"></i>
                                        &nbsp;{{current_event.event_start_date}}
                                    </span>

                  <span class="col-6 text-right mb-1">
                                        <i class="fa fa-fw fa-users" aria-hidden="true"></i>
                                        &nbsp;99 places disponibles
                                    </span>

                  <span class="col-6 text-left mb-1">
                                        <i class="fa fa-fw fa-clock" aria-hidden="true"></i>
                                        &nbsp;{{current_event.event_start_time}}
                                    </span>

                  <span class="col-6 text-right mb-1">
                                        <i class="fa fa-fw fa-map-marker" aria-hidden="true"></i>
                                        &nbsp;{{current_event.place_name}}
                                    </span>
                  <span class="col-6 text-left mb-1">
                                    <i class="fa fa-fw fa-euro-sign" aria-hidden="true"></i>
                                    {{current_event.event_price}} €
                                </span>

                </div>
                <p class="my-3 p-3" v-html="current_event.event_description">
                </p>

                <div class="d-flex justify-content-center">
                  <img :src="current_event.photo_url" class="w-80" alt="Photo de l'évènement">
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">
                  <i class="fa fa-close" aria-hidden="true"></i>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /Modal event information -->

        <div class="col-md-12"
             v-for="event in events"
             :key="event.id_event"
        >
          <div class="event not-reserved">
            <div class="date">
              <div class="day">{{ event.event_start_day }}</div>
              <div class="month">{{ event.event_start_month }}</div>
            </div>

            <div class="desc w-100">
              <div class="title m-b-1">
                <h3>{{ event.event_name }}</h3>
              </div>
              <div class="short-desc">
                <p>

                </p>
                <p>&nbsp;</p>
              </div>

              <div class="reservation w-100 row">

                <a v-if="parseInt(event.bookable)" href="#" class="col-12 btn btn-primary btn-resa" data-toggle="modal"
                   data-target="#anonymousReservation-27">
                  <i class="fas fa-calendar-plus"></i>&nbsp; Je participe
                </a>
                <a href="#" @click="more(event)" class="btn btn-primary col-12 mt-1">
                  <i class="fas fa-info-circle"></i>&nbsp; En savoir plus
                </a>
              </div>
            </div>

            <div class="short-info">
              <div class="time m-t-2">
                <i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;
                <strong>{{ event.event_start_time }}</strong> à <strong>{{ event.event_end_time }}</strong>
              </div>
              <div class="place m-t-2">
                <i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;
                <strong>{{ event.place_name }}feed</strong>
              </div>
              <div class="m-t-2">
                <i class="fa fa-users" aria-hidden="true"></i>&nbsp;
                <strong>{{ event.event_max_dispo }}</strong> places restantes
              </div>
              <div class="m-t-2">
                <i class="fa fa-euro-sign" aria-hidden="true"></i>&nbsp;
                <strong>{{ event.event_price }} €</strong>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="clearfix"></div>
    </div>

  </div>

</template>


<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import frLocale from '@fullcalendar/core/locales/fr';
import interactionPlugin from '@fullcalendar/interaction'


export default {

  components: {
    FullCalendar
  },

  props: [
    'api_url',
    'customer_id'
  ],

  data: function () {
    return {
      events_page: Number,
      events: Array(),
      events_count: Number,
      events_page_count: Number,
      current_event: Object,
      calendar_events: [],
      message: '',
      message_type: '',
      calendar_key: 0,
      calendar_options: {
        events: [],
        plugins: [ dayGridPlugin ],
        initialView: 'dayGridMonth',
        height: 'auto',
        locale: frLocale,
        weekends: true,

        eventClick: function (info) {
          _this.eventClick(info)
        },

      }
    }
  },

  mounted() {
    this.events_page = 1
    this.get_data();
    this.get_calendar();
  },

  watch: {
    events_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.events_page = 1
      }
      if (new_val > this.events_page_count) {
        this.events_page = this.events_page_count
      }
      this.get_data()
    },
  },

  methods: {

    eventClick: function (info) {
      info.jsEvent.preventDefault()
      let _this = this

      console.log(info)

      _this.current_event = {
        availability: info.event.extendedProps.availability,
        bookable: info.event.extendedProps.event_bookable,
        category: info.event.extendedProps.category,
        event_description: info.event.extendedProps.event_description,
        event_max_dispo: info.event.extendedProps.event_max_dispo,
        event_name: info.event.extendedProps.event_name,
        event_price: info.event.extendedProps.event_price,
        event_start_date: info.event.extendedProps.event_start_date,
        event_start_time: info.event.extendedProps.event_start_time,
        id_event: info.event.extendedProps.id,
        photo_url: info.event.extendedProps.photo_url,
        place_name: info.event.extendedProps.place.place_name,

      }

      $('#event-more').modal('show')



    },

    get_calendar: async function () {
      const _this = this
      const secure_key = await get_token();
      let calendar = _this.$refs.eventCalendar.getApi()
      calendar.addEventSource(
          _this.api_url + '/events.json?secure_key=' + secure_key + '&customer_id=' + _this.customer_id
      )
    },

    set_event_page: function (page) {
      page = parseInt(page)
      this.events_page = page
    },

    next_event_page: function () {
      this.events_page++
    },

    prev_event_page: function () {
      this.events_page--
    },

    more: function (event) {
      const _this = this
      _this.current_event = event

      $('#event-more').modal('show')

    },

    get_data: function () {
      const _this = this

      const url = '/modules/dlnkcalendar/actions/events.php?page=' + _this.events_page

      axios.get(url)
          .then(function (response) {
            _this.events = response.data.events
            _this.events_count = response.data.events_count
            _this.events_page_count = response.data.pages_count
            _this.calendar_options.events = response.data.calendar_events
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}

</script>
